import { getCookie } from '../utils/cookie';

export const decodeToken = (token) => {
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
};

export const getTokenPayload = () => {
  const token = getCookie('accessToken');
  if (!token) return null;
  return decodeToken(token);
};

export const isTokenExpired = () => {
  const payload = getTokenPayload();
  if (!payload || !payload.exp) return true;
  return Date.now() >= payload.exp * 1000;
};
